







import Vue from 'vue'
import {
  AdContainerSizeCssRules,
  containerSizeMappingProp,
  containerSizeProp
} from '~/models/ads'
import AdViewService from '~/services/ads/AdViewService'
import { capitalizeAllWords } from '~/utils/string'

export default Vue.extend({
  props: {
    containerSize: containerSizeProp,
    containerSizeMapping: containerSizeMappingProp
  },
  computed: {
    noSizeMappingStyleRules(): AdContainerSizeCssRules | null {
      if (this.containerSizeMapping.length === 0) {
        const rules = this.$dep(AdViewService).getAdPlaceholderCssRules(
          this.containerSize as [number, number]
        )

        if (process.client && rules.width) {
          const containerWidth = parseInt(rules.width.split('px')[0])
          const parentWidth =
            this.$el?.parentElement?.clientWidth || window.outerWidth
          if (containerWidth > parentWidth) {
            rules.width = parentWidth + 'px'
          }
        }
        return rules
      }
      // else it will be handled by the dynamic css media query rules
      return null
    }
  },
  methods: {
    capitalizeAllWords
  }
})
